import React from 'react';
import { Card, CardActions, CardContent, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { bookmarkIcon } from '../../assets/icons';

export const ConcussionResources = () => {
  const { t } = useTranslation();

  return (
    <Card sx={{ borderRadius: 4 }}>
      <CardHeader title={t('UNDERSTANDING_CONCUSSION')} />
      <CardContent sx={{ alignItems: 'center', display: 'flex' }}>
        {bookmarkIcon}
        {t('LEARN_ABOUT_CONCUSSIONS')}
      </CardContent>
      <CardActions>
        <Link to="/guardian#resources">{t('GO_TO_CONCUSSION_RESOURCES')}</Link>
      </CardActions>
    </Card>
  );
};
